
import { defineComponent, nextTick, PropType, ref } from "vue";

export default defineComponent({
  name: "lux-composer",
  props: {
    sending: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    remaining: { type: Number as PropType<number | null>, default: null },
    suggestions: { type: Array as PropType<string[]>, default: () => [] },
    showSuggestions: { type: Boolean, default: false },
    placeholder: { type: String, default: "Pergunte alguma coisa para a Lux..." },
  },
  emits: ["send"],
  setup(props, { emit }) {
    const draft = ref("");
    const input = ref<HTMLTextAreaElement | null>(null);

    // O textarea cresce até 6 linhas e depois rola, para o campo não engolir a
    // conversa quando o aluno cola um bloco grande de log.
    function autoGrow() {
      const el = input.value;

      if (!el) {
        return;
      }

      el.style.height = "auto";
      el.style.height = `${Math.min(el.scrollHeight, 160)}px`;
    }

    function submit() {
      if (!draft.value.trim() || props.disabled || props.sending) {
        return;
      }

      emit("send", draft.value);
      draft.value = "";

      nextTick(autoGrow);
    }

    /**
     * Devolve o texto ao campo quando o envio falha, para o aluno não perder o
     * que escreveu.
     */
    function restore(text: string) {
      draft.value = text;
      nextTick(autoGrow);
    }

    function pick(suggestion: string) {
      emit("send", suggestion);
    }

    return { draft, input, autoGrow, submit, restore, pick };
  },
});
